import { aimProvocation } from "@karrtopelka/cards/provocations";
import type { CardProps } from "@karrtopelka/cards/types";
import type { SubmitResult } from "@karrtopelka/game-kit";

const RANKLINE_MIN_TOTAL = 10;

export function buildAimCard(
  hits: number,
  handle: string,
  submit: SubmitResult | null,
): CardProps {
  const props: CardProps = {
    game: "aim",
    display: String(hits),
    handle,
    provocation: aimProvocation(hits),
    date: new Date().toISOString().slice(0, 10),
  };
  if (submit && submit.total >= RANKLINE_MIN_TOTAL) {
    return { ...props, rankLine: `top ${submit.percentile}% aim` };
  }
  return props;
}
